import type { FreeLinkConfig } from '@elfsight/widget-free-link';
import { getColorWithAlpha, getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { isInlineLayout } from '../../../utils';
import { useLayout } from '../../layout/layout-context';

const BACKGROUNDS_WITHOUT_COLOR = ['image', 'gradient'];

export const useFreeLinkStyles = (): FreeLinkConfig['style'] => {
  const {
    layout,
    headingText,
    theme: {
      themeSettings: {
        headingColor,
        timerColor,
        background: { type, color, imageFile }
      }
    }
  } = useSettings();
  const { isMobileBreakpoint } = useLayout();

  if (isInlineLayout(layout)) {
    return {
      link: {
        transform: 'none',
        left: '0',
        margin: `4px auto -${isMobileBreakpoint ? 8 : 28}px`
      }
    };
  }

  const withImageBackground = type === 'image' && imageFile;
  const freeLinkMainColor = (() => {
    if (BACKGROUNDS_WITHOUT_COLOR.includes(type) || !color) {
      return headingText ? headingColor : timerColor;
    }

    return getInvertedColor(color);
  })();

  const freeLinkBackgroundColor = getColorWithAlpha(freeLinkMainColor, 0.05);
  const freeLinkTextColor = getColorWithAlpha(freeLinkMainColor, 0.5);

  return {
    link: {
      position: 'absolute',
      top: 0,
      height: '22px',
      padding: '4px 0',
      width: '100%',
      maxWidth: 'unset',
      margin: 0,
      background: freeLinkBackgroundColor,
      color: freeLinkTextColor,
      backdropFilter: withImageBackground ? 'blur(20px)' : undefined
    }
  };
};
